const country = {
  ABW: '阿魯巴',
  AFG: '阿富汗',
  AGO: '安哥拉',
  AIA: '安圭拉',
  ALA: '奧蘭',
  ALB: '阿爾巴尼亞',
  AND: '安道爾',
  ARE: '阿聯酋',
  ARG: '阿根廷',
  ARM: '亞美尼亞',
  ASM: '美屬薩摩亞',
  ATA: '南極洲',
  ATF: '法屬南方和南極洲領地',
  ATG: '安提瓜和巴布達',
  AUS: '澳大利亞',
  AUT: '奧地利',
  AZE: '阿塞拜疆',
  BDI: '布隆迪',
  BEL: '比利時',
  BEN: '貝寧',
  BES: '荷蘭加勒比區',
  BFA: '布基納法索',
  BGD: '孟加拉國',
  BGR: '保加利亞',
  BHR: '巴林',
  BHS: '巴哈馬',
  BIH: '波斯尼亞和黑塞哥維那',
  BLM: '聖巴泰勒米',
  BLR: '白俄羅斯',
  BLZ: '伯利茲',
  BMU: '百慕大',
  BOL: '玻利維亞',
  BRA: '巴西',
  BRB: '巴巴多斯',
  BRN: '文萊',
  BTN: '不丹',
  BVT: '布韋島',
  BWA: '博茨瓦納',
  CAF: '中非',
  CAN: '加拿大',
  CCK: '科科斯（基林）群島',
  CHE: '瑞士',
  CHL: '智利',
  CHN: '中國',
  CIV: '科特迪瓦',
  CMR: '喀麥隆',
  COD: '剛果（金）',
  COG: '剛果（布）',
  COK: '庫克群島',
  COL: '哥倫比亞',
  COM: '科摩羅',
  CPV: '佛得角',
  CRI: '哥斯達黎加',
  CUB: '古巴',
  CUW: '庫拉索',
  CXR: '聖誕島',
  CYM: '開曼群島',
  CYP: '塞浦路斯',
  CZE: '捷克',
  DEU: '德國',
  DJI: '吉布提',
  DMA: '多米尼克',
  DNK: '丹麥',
  DOM: '多米尼加',
  DZA: '阿爾及利亞',
  ECU: '厄瓜多爾',
  EGY: '埃及',
  ERI: '厄立特里亞',
  ESH: '阿拉伯撒哈拉民主共和國',
  ESP: '西班牙',
  EST: '愛沙尼亞',
  ETH: '埃塞俄比亞',
  FIN: '芬蘭',
  FJI: '斐濟',
  FLK: '福克蘭群島',
  FRA: '法國',
  FRO: '法羅群島',
  FSM: '密克羅尼西亞聯邦',
  GAB: '加蓬',
  GBR: '英國',
  GEO: '格魯吉亞',
  GGY: '根西',
  GHA: '加納',
  GIB: '直布羅陀',
  GIN: '幾內亞',
  GLP: '瓜德羅普',
  GMB: '岡比亞',
  GNB: '幾內亞比紹',
  GNQ: '赤道幾內亞',
  GRC: '希臘',
  GRD: '格林納達',
  GRL: '格陵蘭',
  GTM: '危地馬拉',
  GUF: '法屬圭亞那',
  GUM: '關島',
  GUY: '圭亞那',
  HKG: '香港',
  HMD: '赫德島和麥克唐納群島',
  HND: '洪都拉斯',
  HRV: '克羅地亞',
  HTI: '海地',
  HUN: '匈牙利',
  IDN: '印尼',
  IMN: '馬恩島',
  IND: '印度',
  IOT: '英屬印度洋領地',
  IRL: '愛爾蘭',
  IRN: '伊朗',
  IRQ: '伊拉克',
  ISL: '冰島',
  ISR: '以色列',
  ITA: '意大利',
  JAM: '牙買加',
  JEY: '澤西',
  JOR: '約旦',
  JPN: '日本',
  KAZ: '哈薩克斯坦',
  KEN: '肯尼亞',
  KGZ: '吉爾吉斯斯坦',
  KHM: '柬埔寨',
  KIR: '基里巴斯',
  KNA: '聖基茨和尼維斯',
  KOR: '韓國',
  KWT: '科威特',
  LAO: '老撾',
  LBN: '黎巴嫩',
  LBR: '利比里亞',
  LBY: '利比亞',
  LCA: '聖盧西亞',
  LIE: '列支敦士登',
  LKA: '斯里蘭卡',
  LSO: '萊索托',
  LTU: '立陶宛',
  LUX: '盧森堡',
  LVA: '拉脫維亞',
  MAC: '澳門',
  MAF: '法屬聖馬丁',
  MAR: '摩洛哥',
  MCO: '摩納哥',
  MDA: '摩爾多瓦',
  MDG: '馬達加斯加',
  MDV: '馬爾代夫',
  MEX: '墨西哥',
  MHL: '馬紹爾群島',
  MKD: '北馬其頓',
  MLI: '馬里',
  MLT: '馬耳他',
  MMR: '緬甸',
  MNE: '黑山',
  MNG: '蒙古國',
  MNP: '北馬里亞納群島',
  MOZ: '莫桑比克',
  MRT: '毛里塔尼亞',
  MSR: '蒙特塞拉特',
  MTQ: '馬提尼克',
  MUS: '毛里求斯',
  MWI: '馬拉維',
  MYS: '馬來西亞',
  MYT: '馬約特',
  NAM: '納米比亞',
  NCL: '新喀裡多尼亞',
  NER: '尼日爾',
  NFK: '諾福克島',
  NGA: '尼日利亞',
  NIC: '尼加拉瓜',
  NIU: '紐埃',
  NLD: '荷蘭',
  NOR: '挪威',
  NPL: '尼泊爾',
  NRU: '瑙魯',
  NZL: '新西蘭',
  OMN: '阿曼',
  PAK: '巴基斯坦',
  PAN: '巴拿馬',
  PCN: '皮特凱恩群島',
  PER: '秘魯',
  PHL: '菲律賓',
  PLW: '帕勞',
  PNG: '巴布亞新幾內亞',
  POL: '波蘭',
  PRI: '波多黎各',
  PRK: '朝鮮',
  PRT: '葡萄牙',
  PRY: '巴拉圭',
  PSE: '巴勒斯坦',
  PYF: '法屬波利尼西亞',
  QAT: '卡塔爾',
  REU: '留尼汪',
  ROU: '羅馬尼亞',
  RUS: '俄羅斯',
  RWA: '盧旺達',
  SAU: '沙特阿拉伯',
  SDN: '蘇丹',
  SEN: '塞內加爾',
  SGP: '新加坡',
  SGS: '南喬治亞和南桑威奇群島',
  SHN: '聖赫勒拿、阿森松和特里斯坦-達庫尼亞',
  SJM: '斯瓦爾巴和揚馬延',
  SLB: '所羅門群島',
  SLE: '塞拉利昂',
  SLV: '薩爾瓦多',
  SMR: '聖馬力諾',
  SOM: '索馬里',
  SPM: '聖皮埃爾和密克隆',
  SRB: '塞爾維亞',
  SSD: '南蘇丹',
  STP: '聖多美和普林西比',
  SUR: '蘇里南',
  SVK: '斯洛伐克',
  SVN: '斯洛文尼亞',
  SWE: '瑞典',
  SWZ: '斯威士蘭',
  SXM: '聖馬丁',
  SYC: '塞舌爾',
  SYR: '敘利亞',
  TCA: '特克斯和凱科斯群島',
  TCD: '乍得',
  TGO: '多哥',
  THA: '泰國',
  TJK: '塔吉克斯坦',
  TKL: '托克勞',
  TKM: '土庫曼斯坦',
  TLS: '東帝汶',
  TON: '湯加',
  TTO: '特立尼達和多巴哥',
  TUN: '突尼斯',
  TUR: '土耳其',
  TUV: '圖瓦盧',
  TWN: '台灣地區',
  TZA: '坦桑尼亞',
  UGA: '烏干達',
  UKR: '烏克蘭',
  UMI: '美國本土外小島嶼',
  URY: '烏拉圭',
  USA: '美國',
  UZB: '烏茲別克斯坦',
  VAT: '梵蒂岡',
  VCT: '聖文森特和格林納丁斯',
  VEN: '委內瑞拉',
  VGB: '英屬維爾京群島',
  VIR: '美屬維爾京群島',
  VNM: '越南',
  VUT: '瓦努阿圖',
  WLF: '瓦利斯和富圖納',
  WSM: '薩摩亞',
  YEM: '也門',
  ZAF: '南非',
  ZMB: '贊比亞',
  ZWE: '津巴布韋',
  UNIVERSAL: '全世界'
};
export default country;
